export const TABORDION_CONTAINER_ID = 'product-page-tabordion'
// TODO: change it to ACCORDION after ab test is completed

// -------- FEATURE FLAGS --------- //

export const ACCORDION_AB_TEST_FLAG = 'ab-test-product-page-v2-accordions'

export const STICKY_ADD_TO_CART_FLAG = 'ab-test-product-sticky-add-to-cart'

export const SHOW_MORE_RECOMMENDED_PRODUCTS_FLAG = 'abtest-show-more-recommended-products-pdp'

export const PRODUCT_PAGE_VARIANT_V2_FLAG = 'wt-product-page-variant-v2'

export const PRODUCT_PAGE_VARIANT_V2_PRICE_DIFFERENCE_FLAG =
  'wt-product-page-variant-v2-price-difference'
